import type { AppManifest } from '@api/apps';
import { apiPage, type AppFramePage } from './appFramePage';
import type { RunSetupTarget } from './runHost';

export const framePageUrl = (appKey: string, runId: string | undefined, target: RunSetupTarget): string => {
  if (runId) return `/api/v1/apps/runs/${encodeURIComponent(runId)}/page`;
  return target === 'draft'
    ? `/api/v1/app-builder/apps/${encodeURIComponent(appKey)}/page`
    : `/api/v1/apps/${encodeURIComponent(appKey)}/page`;
};

export const framePage = (
  manifest: AppManifest,
  appKey: string,
  runId: string | undefined,
  target: RunSetupTarget,
): AppFramePage => apiPage(
    framePageUrl(appKey, runId, target),
    manifest.presentation?.page ?? `${appKey}:${manifest.version}`,
  );
